import React, { useEffect, useState } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminSettings() {
  const [s, setS] = useState(null);
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    api.get("/admin/settings").then((r) => setS(r.data));
    api.get("/admin/audit?limit=50").then((r) => setLogs(r.data.items));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async () => {
    await api.patch("/admin/settings", s);
    toast.success("Settings saved");
  };

  if (!s) return <div className="p-10">Loading…</div>;
  return (
    <div className="App min-h-screen">
      <Navbar />
      <div className="max-w-5xl mx-auto px-6 lg:px-8 py-10">
        <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-2">Settings</div>
        <h1 className="font-heading font-black tracking-tighter text-4xl md:text-5xl mb-8">App configuration.</h1>

        <div className="border border-border bg-white p-6 space-y-4">
          <div className="grid md:grid-cols-2 gap-4">
            <div><Label>Product name</Label><Input data-testid="settings-product-name" value={s.product_name} onChange={(e) => setS({ ...s, product_name: e.target.value })} className="mt-1" /></div>
            <div><Label>Support email</Label><Input value={s.support_email} onChange={(e) => setS({ ...s, support_email: e.target.value })} className="mt-1" /></div>
            <div className="md:col-span-2"><Label>Tagline</Label><Input value={s.product_tagline} onChange={(e) => setS({ ...s, product_tagline: e.target.value })} className="mt-1" /></div>
            <div className="md:col-span-2"><Label>Company address</Label><Textarea rows={2} value={s.company_address} onChange={(e) => setS({ ...s, company_address: e.target.value })} className="mt-1" /></div>
            <div><Label>Default currency</Label><Input value={s.default_currency} onChange={(e) => setS({ ...s, default_currency: e.target.value })} className="mt-1" /></div>
            <div><Label>Available currencies (comma separated)</Label><Input value={s.available_currencies.join(",")} onChange={(e) => setS({ ...s, available_currencies: e.target.value.split(",").map((x) => x.trim()) })} className="mt-1" /></div>
            <div><Label>Replacement window (days)</Label><Input type="number" value={s.replacement_window_days} onChange={(e) => setS({ ...s, replacement_window_days: Number(e.target.value) })} className="mt-1" /></div>
            <div><Label>Download link TTL (minutes)</Label><Input type="number" value={s.download_link_ttl_minutes} onChange={(e) => setS({ ...s, download_link_ttl_minutes: Number(e.target.value) })} className="mt-1" /></div>
          </div>
          <Button data-testid="settings-save" onClick={save} className="rounded-sm">Save settings</Button>
        </div>

        <div className="mt-10">
          <h2 className="font-heading font-bold text-2xl mb-4">Audit log</h2>
          <div className="border border-border bg-white">
            <table className="w-full text-sm">
              <thead className="bg-muted text-left">
                <tr className="text-xs uppercase tracking-widest-2 text-muted-foreground">
                  <th className="p-3">Time</th>
                  <th className="p-3">Actor</th>
                  <th className="p-3">Action</th>
                  <th className="p-3">Object</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((l) => (
                  <tr key={l.log_id} className="border-t border-border">
                    <td className="p-3 text-xs font-mono text-muted-foreground">{new Date(l.created_at).toLocaleString()}</td>
                    <td className="p-3 text-xs">{l.actor_email || l.actor_id || "—"}</td>
                    <td className="p-3 font-mono text-xs">{l.action}</td>
                    <td className="p-3 font-mono text-xs">{l.object_type}:{l.object_id?.slice(0, 12)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
